<template>
    <div class="vld-parent">
       <loading :active="isLoading" 
       :can-cancel="true" 
       :on-cancel="onCancel"
       :color="'#808080'"
       :height="120"
       :width="400"
       :is-full-page="fullPage"></loading>
   </div>
</template>

<script>
   import Loading from 'vue3-loading-overlay';
   import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
   
   export default {
       name: "VueLoading",
       data() {
           return {
               fullPage: true
           }
       },
       props: {
           isLoading: Boolean
       },
       components: {
           Loading
       }
   }
</script>